/* eslint-disable no-restricted-syntax */
export const MIME_TYPES = {
  PDF: 'application/pdf',
  JSON: 'application/json',
  CSV: 'text/csv',
  XML: 'application/xml',
  OCTET_STREAM: 'application/octet-stream',
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  WORD_DOCX:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WORD_DOC: 'application/msword',
  WORD: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ] as const,
  EXCEL_XLSX:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  EXCEL_XLS: 'application/vnd.ms-excel',
  EXCEL: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ] as const,
} as const;

export const MIME_TYPE_GROUPS = {
  WORD_WITH_FALLBACK: [...MIME_TYPES.WORD, MIME_TYPES.OCTET_STREAM],
  EXCEL_WITH_FALLBACK: [...MIME_TYPES.EXCEL, MIME_TYPES.OCTET_STREAM],
} as const;
